import React from 'react';

import styled from '@emotion/styled';
import type { HStackProps } from '@rtkwlf/fenrir-react';
import { HStack } from '@rtkwlf/fenrir-react';

import { ComingSoonBadge } from '@packages/components/coming-soon/coming-soon-badge/coming-soon-badge';
import type { FeatureFlagKey } from '@packages/platform/feature-flags/feature-flags';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

const StyledComingSoonWrapper = styled(HStack)({
  'button:disabled': {
    opacity: '1',
  },
});

type ComingSoonProps = {
  featureFlagKey: FeatureFlagKey;
} & HStackProps;

export const ComingSoon: React.FC<React.PropsWithChildren<ComingSoonProps>> = ({
  children,
  featureFlagKey,
  ...rest
}) => {
  const [featureFlag] = useFeatureFlag(featureFlagKey);

  if (!featureFlag) return null;

  return (
    <HStack {...rest}>
      <ComingSoonBadge />
      <StyledComingSoonWrapper
        aria-disabled
        data-testid="coming-soon-wrapper"
        opacity="50"
        pointerEvents="none"
        {...rest}
      >
        {children}
      </StyledComingSoonWrapper>
    </HStack>
  );
};
